"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobType = exports.JobStatus = void 0;
var JobStatus;
(function (JobStatus) {
    JobStatus["CREATED"] = "CREATED";
    JobStatus["MESSAGE_PUBLISHED"] = "MESSAGE_PUBLISHED";
    JobStatus["FAILED"] = "FAILED";
})(JobStatus = exports.JobStatus || (exports.JobStatus = {}));
/**
 * Media transcoder job type.
 * */
var JobType;
(function (JobType) {
    /** Elastic Transcoder */
    JobType["et"] = "et";
    JobType["ffmpeg"] = "ffmpeg";
})(JobType = exports.JobType || (exports.JobType = {}));
//# sourceMappingURL=jobs.js.map